import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import * as Icons from '../../../../shared/vector-images';
import { spanner } from '../../../../shared/vector-images';

interface CategoryIconProps {
  iconBaseShape?: string;
  renderAsThumbnail?: boolean;
}

const CategoryIcon: FC<CategoryIconProps> = ({
  iconBaseShape,
  renderAsThumbnail,
}) => {
  const theme = useTheme();

  let iconSize = 90;
  let imageSize = 200;
  if (renderAsThumbnail) {
    iconSize = 48;
    imageSize = 80;
  }

  // @ts-expect-error -- legacy issue `iconBaseShape` may be undefined
  // eslint-disable-next-line import/namespace
  const iconShapeToDisplay = Icons[iconBaseShape];

  let categoryIconToDisplay = spanner();
  if (iconShapeToDisplay) {
    categoryIconToDisplay = iconShapeToDisplay();
  }

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width={renderAsThumbnail ? imageSize : undefined}
      height={imageSize}
      bg={theme.colors.secondarylight}
    >
      <Icons.ReactSvg
        toDisplay={categoryIconToDisplay}
        options={{
          fillColor: theme.colors.secondary,
        }}
        width={iconSize}
        height={iconSize}
      />
    </Box>
  );
};

CategoryIcon.defaultProps = {
  renderAsThumbnail: false,
  iconBaseShape: 'spanner',
};

export default CategoryIcon;
